import React from "react";
const InputFieldLogin = ({
  label,
  type,
  name,
  size,
  placeholder,
  required,
  value,
  onChange,
  disabled,
  checked,
}) => {
  const handleChange = (e) => {
    if (type === "checkbox" || type === "radio") {
      const { name, checked } = e.target;
      onChange("input", name, checked);
    } else {
      const { name, value } = e.target;
      onChange("input", name, value);
    }
  };

  // "button", "checkbox", "color", "date", "datetime-local", "email", "file", "hidden", "image", "month", "number", "password", "radio", "range", "reset", "search", "submit", "tel", "text", "time", "url", "week"

  return (
    <div className={"col-lg-" + size}>
      {type === "checkbox" || type === "radio" ? (
        <>
          <label className="ui-checkbox ui-checkbox-info">
            <input
              required={required}
              className="form-check-input"
              type="checkbox"
              name={name}
              value={value}
              checked={checked}
              onChange={handleChange}
            />
            <span className="input-span"></span>
            {label}
          </label>
        </>
      ) : (
        <>
          <div className="form-group">
            <div className="input-icon">
              <i className={label}></i>
            </div>
            <input
              className="form-control"
              disabled={disabled}
              required={required}
              type={type}
              name={name}
              placeholder={placeholder}
              value={value}
              onChange={handleChange}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default InputFieldLogin;
